export * from './definitions';
import { registerPlugin } from '@capacitor/core';
const GetAppInfo = registerPlugin('GetAppInfo', {
    web: () => import('./web').then(m => new m.GetAppInfoWeb()),
});
export * from './definitions';
export { GetAppInfo };
//# sourceMappingURL=index.js.map